import { request } from 'ice';
import { INBOUNDSERVICE } from '@/const';

// 出库面板tip---order
async function outTipsOrder(data) {
  console.log('outTipsOrder data=', data);
  return await request({
    // url: `${INBOUNDSERVICE}/otaskBoard/countOrderQtyByStatus`,
    url: `${INBOUNDSERVICE}/outboundBoard/countLinkOrderQty`,
    method: 'POST',
    data,
  });
}

// 出库面板tip---pcs
async function outTipsPCS(data) {
  return await request({
    // url: `${INBOUNDSERVICE}/otaskBoard/countPcsQtyByStatus`,
    url: `${INBOUNDSERVICE}/outboundBoard/countPcsQtyByStatus`,
    method: 'POST',
    data,
  });
}

// 出库面板tip---ppo
async function outTipsPPO(data) {
  return await request({
    url: `${INBOUNDSERVICE}/outboundBoard/countPpoQtyByStatus`,
    method: 'POST',
    data,
  });
}

export { outTipsOrder, outTipsPCS, outTipsPPO };
